/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typewriter_GreetingInputs */

const en_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hi,`)
};

const ar_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرحبًا،`)
};

const bn_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হাই,`)
};

const de_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hallo,`)
};

const es_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hola,`)
};

const fr_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bonjour,`)
};

const pt_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Olá,`)
};

const zh_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嗨，`)
};

const tr_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merhaba,`)
};

const ru_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Привет!`)
};

const pl_typewriter_greeting = /** @type {(inputs: Typewriter_GreetingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cześć,`)
};

/**
* | output |
* | --- |
* | "Hi," |
*
* @param {Typewriter_GreetingInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const typewriter_greeting = /** @type {((inputs?: Typewriter_GreetingInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typewriter_GreetingInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_typewriter_greeting(inputs)
	if (locale === "bn") return bn_typewriter_greeting(inputs)
	if (locale === "de") return de_typewriter_greeting(inputs)
	if (locale === "es") return es_typewriter_greeting(inputs)
	if (locale === "fr") return fr_typewriter_greeting(inputs)
	if (locale === "pt") return pt_typewriter_greeting(inputs)
	if (locale === "zh") return zh_typewriter_greeting(inputs)
	if (locale === "tr") return tr_typewriter_greeting(inputs)
	if (locale === "ru") return ru_typewriter_greeting(inputs)
	if (locale === "pl") return pl_typewriter_greeting(inputs)
	return en_typewriter_greeting(inputs)
});